import { useQuery } from "@apollo/react-hooks";
import {
    Badge,
    Button,
    Labelled,
    Sheet,
    Stack,
    Tooltip,
} from "@shopify/polaris";
import { get } from "lodash";
import React, { useState } from "react";
import { GET_ORDER_PROGRESS } from "../../graphql/queries";
import { handleError } from "../../helper";
import { CustomTimeline } from "../shared/CustomTimeline";
import { SheetPolaris } from "../shared/SheetPolaris";
import SkeletonText from "../shared/SkeletonText";

export default function OrderProgress({
    lastProgress,
    fulfillmentID,
    orderID,
}) {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    if (!lastProgress) return null;

    return (
        <div style={{ marginTop: 5 }}>
            <Stack spacing="tight" alignment="center">
                <Labelled children="Order Progress: " />
                <Tooltip content={lastProgress}>
                    <Button onClick={handleOpen} plain>
                        <Badge>{lastProgress}</Badge>
                    </Button>
                </Tooltip>
            </Stack>

            <OrderProgressSheet
                open={open}
                onClose={handleClose}
                orderID={orderID}
                fulfillmentID={fulfillmentID}
            />
        </div>
    );
}

function OrderProgressSheet({ open, onClose, fulfillmentID, orderID }) {
    const { data, loading, error } = useQuery(GET_ORDER_PROGRESS, {
        variables: {
            filter: { orderID, fulfillmentID },
        },
        skip: !orderID || !fulfillmentID || !open,
    });

    const values = formatOrderProgress(data);
    return (
        <Sheet open={open} onClose={onClose}>
            <SheetPolaris
                handleSheetChange={onClose}
                title="Order Progress History"
            >
                {loading ? (
                    <SkeletonText />
                ) : error ? (
                    <div>Error: {handleError(error?.toString())}</div>
                ) : (
                    <CustomTimeline data={values} timeFormat={"LL"} />
                )}
            </SheetPolaris>
        </Sheet>
    );
}

function formatOrderProgress(data) {
    const nodes = get(data, "getOrderProgress") || [];

    const res = [];
    for (let node of nodes) {
        if (!node || !node.id) continue;

        res.push({
            id: node.id,
            title: node.status,
            createdAt: node.syncAt || node.createdAt,
        });
    }

    return res;
}
